import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import axios from 'axios';
import toast from 'react-hot-toast';
import { API_BASE_URL, getBearerToken } from '../../functions';

const UmrahTimeUpdate = ({ show, setShow, selectedBooking }) => {
  const handleClose = () => setShow(false);
  const [loading, setLoading] = useState(false);
  const [holdExpiresAt, setHoldExpiresAt] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!holdExpiresAt) {
      toast.error('Please select a new expiry date and time');
      return;
    }

    setLoading(true);
    const tid = toast.loading('Updating hold time...');
    
    try {
      const response = await axios.post(`${API_BASE_URL}/umrah-booking/hold`, {
        booking_id: selectedBooking?.id,
        hold_expires_at: holdExpiresAt
      }, {
        headers: {
          'Authorization': `Bearer ${getBearerToken()}`
        }
      });

      if (response.data.status) {
        toast.success('Hold time updated successfully');
        handleClose();
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        toast.error(response.data.message || 'Failed to update hold time');
      }
    } catch (error) {
      console.error('Error updating hold time:', error);
      toast.error(error.response?.data?.message || 'Failed to update hold time');
    } finally {
      setLoading(false);
      toast.dismiss(tid);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Extend Hold Time</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Booking ID: {selectedBooking?.id}</label>
          </div>
          <div className="mb-3">
            <label className="form-label">Package: {selectedBooking?.umrah_package?.title}</label>
          </div>
          <div className="mb-3">
            <label className="form-label">Current Hold Expires: {selectedBooking?.hold_expires_at ? new Date(selectedBooking.hold_expires_at).toLocaleString() : 'Not set'}</label>
          </div>
          <Form.Group className="mb-3">
            <Form.Label>New Hold Expiry Date & Time</Form.Label>
            <Form.Control
              type="datetime-local"
              value={holdExpiresAt}
              onChange={(e) => setHoldExpiresAt(e.target.value)}
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? 'Updating...' : 'Update Hold Time'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default UmrahTimeUpdate;